import React from 'react';
import {
  CreditCardOutlined,
  GiftOutlined,
  OrderedListOutlined,
  RiseOutlined,
  TrophyOutlined
} from '@ant-design/icons';

import { FEATURES } from 'appConstants';
import { useFeatureFlags } from 'hooks';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import SelectionTile, { TileRow } from '../components/SelectionTile';
import { WizardEntry } from '../components/WizardFrame';
import { chooseType, IWizardStepProps, WizardCampaignType } from '../wizardModel';

// The module's own type flags (`CampaignTypeSelector`); Instant Reward is the fifth tile.
const TYPE_TILES: { type: WizardCampaignType; flag: string; icon: React.ReactNode }[] = [
  { type: 'stamp', flag: FEATURES.STAMP.key, icon: <CreditCardOutlined /> },
  { type: 'progress', flag: FEATURES.PROGRESS_CAMPAIGN.key, icon: <RiseOutlined /> },
  { type: 'quest', flag: FEATURES.QUEST_CAMPAIGNS.key, icon: <OrderedListOutlined /> },
  { type: 'game', flag: FEATURES.GAME_CAMPAIGN.key, icon: <TrophyOutlined /> },
  { type: 'instant_outcome', flag: FEATURES.INSTANT_REWARD_CAMPAIGN.key, icon: <GiftOutlined /> }
];

/** 6778:17754: pick the campaign type; the tile is the only forward control. */
const TypeStep: React.FC<IWizardStepProps> = ({ state, update }) => {
  const { t } = useMultiLanguageTranslation();
  const flags = useFeatureFlags() as Record<string, boolean | undefined>;
  return (
    <WizardEntry title={t(`${TOrbit}.wizard.type.title`)} step={null} onBack={null}>
      <TileRow $fixed={250}>
        {TYPE_TILES.filter(tile => flags[tile.flag] === true).map(tile => (
          <SelectionTile
            key={tile.type}
            flat
            icon={tile.icon}
            label={t(`${TOrbit}.wizard.type.${tile.type}`)}
            selected={state.type === tile.type}
            onSelect={() => update(current => chooseType(current, tile.type))}
            testId="orbit-wizard-type-tile"
          />
        ))}
      </TileRow>
    </WizardEntry>
  );
};

export default TypeStep;
